import { Navigate } from "react-router";
import { selectUser, selectUserToken } from "../store/slices/auth";
import { useSelector } from "../store/store";

export const Home = () => {
  const userToken = useSelector(selectUserToken);
  const user = useSelector(selectUser);
  const isAuthenticated = user && userToken;
  const isConfirmed = user?.is_confirmed;

  if (isAuthenticated && isConfirmed) {
    return <Navigate to="/dashboard" />;
  }

  return <Navigate to="login" />;
};
